module.exports = __webpack_public_path__ + "blackscentcandle.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/blackscentcandle.png
// module id = 867
// module chunks = 0